import React, { useEffect, useRef } from "react";
import { useLang } from "@/lib/i18n";

const TXT = {
  ru: { top: "Проверенные фото", sub: "Запись на просмотр 24/7 без звонков" },
  en: { top: "Verified photos", sub: "Book a viewing 24/7, no phone calls" },
};

let PLAYED = false;

export const AnimatedPromise = ({ className = "", align = "center" }) => {
  const { lang } = useLang();
  const txt = TXT[lang] || TXT.ru;
  const alignCls = align === "left" ? "items-start text-left" : "items-center text-center";
  const topRef = useRef(null);
  const subRef = useRef(null);

  useEffect(() => {
    let cancelled = false;
    const anims = [];
    const run = () => {
      if (cancelled) return;
      const top = topRef.current;
      const sub = subRef.current;
      if (!top || !sub) return;

      if (PLAYED) {
        top.style.clipPath = "inset(-25% 0% -25% 0)";
        sub.style.opacity = 1;
        return;
      }

      const DUR = 2200;
      const DELAY = 150;
      const EASE = "cubic-bezier(0.62,0,0.34,1)";

      const a1 = top.animate(
        [{ clipPath: "inset(-25% 100% -25% 0)" }, { clipPath: "inset(-25% 0% -25% 0)" }],
        { duration: DUR, delay: DELAY, easing: EASE, fill: "both" }
      );
      a1.onfinish = () => { PLAYED = true; };
      anims.push(a1);

      anims.push(sub.animate(
        [{ opacity: 0, transform: "translateY(7px)" }, { opacity: 1, transform: "translateY(0)" }],
        { duration: 600, delay: DELAY + DUR + 60, easing: "ease-out", fill: "both" }
      ));
    };

    if (document.fonts && document.fonts.ready) document.fonts.ready.then(run);
    else run();
    return () => { cancelled = true; anims.forEach((a) => a.cancel()); };
  }, [lang]);

  return (
    <div data-testid="promise-title" className={`relative flex flex-col justify-center leading-none ${alignCls} ${className}`}>
      <div className="relative inline-flex overflow-visible">
        <span
          ref={topRef}
          className="brush-title inline-block text-xl sm:text-2xl md:text-[27px]"
          style={{ clipPath: "inset(-25% 100% -25% 0)" }}
        >
          {txt.top}
        </span>
      </div>
      <span
        ref={subRef}
        className="text-[#F26B2A] font-extrabold text-[10px] sm:text-xs tracking-tight whitespace-nowrap mt-1"
        style={{ opacity: 0 }}
      >
        {txt.sub}
      </span>
    </div>
  );
};
